import {useEffect} from 'react';


// import LTLServices from './LTLServices';
// import Storage from './Storage';
// import TemperatureControlTransportation from './TemperatureControlTransportation';




const ColdChains = () => {
    useEffect(()=>{
        let current_page = window.location.href.split('/').at(-1)
        setTimeout(()=>{
            document.getElementById(`${current_page}`)?.scrollIntoView({ block: 'center', behavior: 'smooth' });
        }, 100)
    })
    window.addEventListener("scroll", function(event) {
        let top = this.scrollY,
            window_width = window.innerWidth,
            header_height = document.querySelector("header").style.height+100;
            // (top > header_height && window_width > 1024) ? document.querySelector("nav").classList.add('fixed-header-desktop') : document.querySelector("nav").classList.remove('fixed-header-desktop')
            (top > header_height && window_width > 1024) ? document.querySelector("a").classList.add('fixed-header-desktop') : document.querySelector("a").classList.remove('fixed-header-desktop')
    }, false);  
    window.addEventListener("scroll", function(event) {
        let top = this.scrollY,
            window_width = window.innerWidth,
            header_height = document.querySelector("header").style.height+100;
            (top > header_height && window_width > 1024) ? document.querySelector("nav").classList.add('fixed-header-desktop') : document.querySelector("nav").classList.remove('fixed-header-desktop')
            // (top > header_height && window_width > 1024) ? document.querySelector("a").classList.add('fixed-header-desktop') : document.querySelector("a").classList.remove('fixed-header-desktop')
    }, false);   
  

  
    return(
        <div>
            <div id='international' className="cold-chain-image">
                <img src='/cold-chain/Cold-Chain-Product-Banner.jpg' alt='' className='w-[100%]'/>
            </div>
            <div className="flex flex-col justify-center gap-4 max-w-[50rem] lg:mx-auto md:mx-auto mx-[2rem]  md:p-[2rem] pt-[1rem] lg:pb-[100px] pb-[100px]">
                <p>
                    Maintaining temperature integrity along the cold chain cannot be achieved simply 
                    by having a range of thermal and refrigerated transport vehicles. It involves logistical 
                    planning, complex operations, as well as special transport arrangements.
                </p>
                <p>
                    With its fleet of temperature-controlled primary and secondary logistics vehicles, warehouses, 
                    distribution centres and strategically located hubs spread across the country and an advanced 
                    Fleet Integrated Management System (FIMS), TCS is one of the largest conveyance providers of 
                    cold chain and the goods labelled as perishable.
                </p>
                <p>
                    From the origin to the destination, TCS capabilities cover the full scope of temperature-sensitive 
                    logistics for businesses including technology, pharmaceuticals, ambient, chilled and frozen 
                    foods, with LTL, FTL, Door to Door and Live Track & Trace services.
                </p>
                
                {/* <div className="MuiFormGroup-root MuiFormGroup-row">
                    <div className="flex">
                        <div className="flex-1 flex flex-col">
                            <div className="flex items-center ">
                                <li><Link to="/coldchain/temperature-control-transportations"  className='font-bold'>Temperature Control Transportation</Link></li>
                            </div>
                           
                            <div className="flex items-center">
                                <li><Link to="/coldchain/storage" className='font-bold'>Storage</Link></li>
                            </div>
                        </div>

                        <div className="flex-1 flex flex-col">
                        <div className="flex items-center">
                                <li><Link to="/coldchain/distribution" className='font-bold'>Distribution</Link></li>
                            </div>

                            <div className="flex items-center">
                                <li><Link to="/coldchain/ltl-services" className='font-bold'>LTL & FTL services</Link></li>
                            </div>
                        </div>
                            
                    </div>
                </div>  */}
                
                 
            </div>
            
            
            {/* <div id="temperature-control-transportations">
                <TemperatureControlTransportation/>
            </div>
            <div id="storage">
                <Storage/>
            </div>
            <div id="distribution">
                <Distribution/>
            </div>
            <div id="ltl-services">
                <LTLServices/>
            </div> */}
        </div>
        
    )
};
export default ColdChains ;